module.exports = __webpack_public_path__ + "static/critical_failure_response_backup.997d8205.png";